import { Modal, TextInput, NumberInput, Text, Button, Stack, Group } from '@mantine/core';
import { useState, useEffect } from 'react';

interface ChangeCalculatorModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: (amountGiven: number, change: number) => void;
  orderTotal: number;
  currencySymbol?: string;
}

export const ChangeCalculatorModal = ({
  opened,
  onClose,
  onConfirm,
  orderTotal,
  currencySymbol = '$'
}: ChangeCalculatorModalProps) => {
  const [amountGiven, setAmountGiven] = useState<number | ''>('');
  const [change, setChange] = useState<number>(0);

  useEffect(() => {
    if (amountGiven !== '' && amountGiven >= orderTotal) {
      setChange(Number((amountGiven - orderTotal).toFixed(2)));
    } else {
      setChange(0);
    }
  }, [amountGiven, orderTotal]);

  const handleConfirm = () => {
    if (amountGiven === '' || amountGiven < orderTotal) return;
    onConfirm(amountGiven, change);
    setAmountGiven('');
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Calculadora de cambio" centered>
      <Stack>
        <TextInput
          label="Total a pagar"
          value={`${currencySymbol}${orderTotal.toFixed(2)}`}
          readOnly
        />

        <NumberInput
          label="Efectivo recibido"
          placeholder="Ingresa el monto recibido"
          hideControls
          value={amountGiven}
          onChange={(value) => setAmountGiven(Number(value))}
          decimalScale={2}
          min={0}
        />

        <Text fw={500}>
          Cambio a entregar:{' '}
          <Text span c={change > 0 ? 'green' : 'red'}>
            {currencySymbol}
            {change.toFixed(2)}
          </Text>
        </Text>

        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={onClose}>
            Cancelar
          </Button>
          <Button onClick={handleConfirm} disabled={amountGiven === '' || amountGiven < orderTotal}>
            Confirmar y crear pedido
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
